/**
 * @generated SignedSource<<dfc67b1f6711e050fc933611e12332cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityTimeSliderFragment_department$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentGolfFacilitiesStartEndTime_department">;
  readonly " $fragmentType": "DepartmentAvailabilityTimeSliderFragment_department";
};
export type DepartmentAvailabilityTimeSliderFragment_department$key = {
  readonly " $data"?: DepartmentAvailabilityTimeSliderFragment_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityTimeSliderFragment_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityTimeSliderFragment_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDepartmentGolfFacilitiesStartEndTime_department"
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "3fe0ecfbd28eeea03c6bd1007ad24759";

export default node;
